import { render } from "./auth-form.vue?vue&type=template&id=aea6fc00&ts=true&lang=pug"
import script from "./auth-form.vue?vue&type=script&lang=ts&setup=true"
export * from "./auth-form.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__